export default __webpack_public_path__ + "static/media/valide.1dc51cd6.svg";